import * as actionTypes from './actionsTypes';
import axios from '../../http-config';

export const fetchDashboardSuccess = (response) => {
    return {
        type: actionTypes.FETCH_DASHBOARD_SUCCESS,
        data: response.data,
        id:response
      
    }
}

export const fetchDashboardFail = (error) => {
    return {
        type: actionTypes.FETCH_DASHBOARD_FAIL,
        error:error
    }
}

export const fetchDashboardStart = () => {
    return {
        type: actionTypes.FETCH_DASHBOARD_START
    }
}

export const fetchDashboard = (payload) => {
    let token = payload.token;
    let interval = payload.interval

    return dispatch => {
        dispatch(fetchDashboardStart());
        const url = `/?interval=${interval}`;

        axios({
            method: 'get',
            url: '/dashboard'+url,
            headers: {'Authorization': `Bearer ${token}`}
        })
        .then((response) => {
            const fetchedEmailManageResponse = response.data;
            dispatch(fetchDashboardSuccess(fetchedEmailManageResponse));
        }).catch(error => {
            dispatch(fetchDashboardFail(error));
        })

    }
}


